export interface FenceSunService {
  service: string;
  price: number;
}
export const fenceSunServices: FenceSunService[] = [
  { service: 'PV-PLANUNG mit Besichtigung vor Ort', price: 299.0 },
  { service: 'Förderstellen & Netzbetreiber Administration je Obj', price: 249.0 },
  { service: 'PV Montage Basisleistung Preis je Tag', price: 279.0 },
  { service: 'PV Modulmontage Preis je Modul 4 - 5 kWp', price: 165.0 },
  { service: 'PV Modulmontage Preis je Modul 6-20 kWp', price: 153.0 },
  { service: 'PV Modulmontage Preis je Modul 21-50 kWp', price: 135.0 },
  { service: 'PV Modulmontage Preis je Modul 51-100 kWp', price: 125.0 },
  { service: 'PV Montage Kabelführung bis zu zentralem Wechsel', price: 599.0 },
  { service: 'PV Montage Kabelführung bis zentralem Wechselric', price: 599.0 },
  { service: 'Kabelführung von Wechselrichter bis Hauptverteiler', price: 1499.0 },
  { service: 'Batteriespeicher-Montage (Batterie einbringen und in', price: 479.0 },
  { service: 'E-Auto Ladestation (Wallbox) Wandmontage & Inbet', price: 579.0 },
  { service: 'PV-Wechselrichter Inbetriebnahme & Anlagen Abna', price: 799.0 },
  { service: 'PV Batteriespeicher Inbetriebnahme', price: 206.0 },
];
